var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIconHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.9402 9.03863V13.4086L20.5502 15.0486V18.4561H3.9502V15.0486L5.5602 13.4086V9.03863C5.5602 5.34863 8.56019 2.34863 12.2502 2.34863C12.9402 2.34863 13.6002 2.44863 14.2202 2.64863C13.8502 3.24863 13.6502 3.94863 13.6502 4.69863C13.6502 6.92863 15.4602 8.72863 17.6802 8.72863C18.1102 8.72863 18.5302 8.65863 18.9202 8.53863C18.9302 8.69863 18.9402 8.86863 18.9402 9.03863Z",
    fill: "#FF6E42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6393 7.03857C18.3393 7.15869 18.0195 7.22852 17.6794 7.22852C16.2893 7.22852 15.1494 6.09863 15.1494 4.69873C15.1494 4.15869 15.3193 3.66895 15.5993 3.25879C16.0593 2.60889 16.8193 2.17871 17.6794 2.17871C19.0793 2.17871 20.2094 3.30859 20.2094 4.69873C20.2094 5.75879 19.5593 6.65869 18.6393 7.03857Z",
    fill: "#FF6E42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1394 18.459H14.6394C14.4996 19.6592 13.4895 20.5991 12.2496 20.5991C11.0096 20.5991 9.99952 19.6592 9.85938 18.459H8.35938C8.50953 20.4893 10.1795 22.0991 12.2496 22.0991C14.3196 22.0991 15.9996 20.4893 16.1394 18.459Z",
    fill: "#FF6E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIconHeader);
export default __webpack_public_path__ + "static/media/notifications_icon_header.a90328181405fa9d3ef9f6c7d292c9b6.svg";
export { ForwardRef as ReactComponent };